import { CSS } from '../cm-modes';

export const transform = source => source;

export const config = {
  name: CSS,
  label: 'CSS',
  for: CSS,
  mode: CSS,
};



// WEBPACK FOOTER //
// ./src/lib/processor/css.js